import { motion, AnimatePresence } from "framer-motion";

export default function Projects() {
  const projects = [
    {
      title: "Modern Hardwares",
      desc: "Website Development, Branding & Digital Marketing",
      status: "Ongoing",
      image: "/image/pro2.png",
      link: "https://www.instagram.com/modernhardwares.store/",
    },
    {
      title: "VJ Dsign Studio",
      desc: "Website Development, Branding & Digital Marketing",
      status: "Ongoing",
      image: "/image/pro3.png",
      link: "https://www.instagram.com/vjdsignstudio/",
    },
 
    {
      title: "Ungal Nilam ",
      desc: "SEO Optimizations",
      status: "Ongoing",
      image: "/image/pro4.png",
      link: "https://www.ungalnilam.com/",
    },
    {
      title: "Sakthi Saaira Herbals ",
      desc: "Digital Marketing & Business Growth Solutions",
      status: "Ongoing",
      image: "/image/pro5.png",
      link: "https://www.instagram.com/sakthi_saaira_herbals_official/?hl=en",
    },
    {
      title: "Shri Kannan Silks",
      desc: "Digital Marketing & Business Growth Solutions",
      status: "Ongoing",
      image: "/image/pro6.png",
      link: "https://www.instagram.com/kannansilk_official/",
    },
    {
      title: "Aaradhya Attires",
      desc: "Digital Marketing",
      status: "Ongoing",
      image: "/image/pro7.png",
      link: "https://www.instagram.com/aaradhyaattires/",
    },
    {
      title: "VAMCO Engineering Syndicate ",
      desc: "Website",
      status: "Completed",
      image: "/image/pro8.png",
      link: "https://vamcouae.com/",
    },
    {
      title: "Vasan Hospital ",
      desc: "Digital Marketing",
      status: "Completed",
      image: "/image/pro9.jpg",
      link: "https://www.instagram.com/vasan_hospital/",
    },
    {
      title: "VJ Dsign Studio",
      desc: "Website ",
      status: "Completed",
      image: "/image/pro3.png",
      link: "https://vjdsignstudio.com/",
    },

  ];

  return (
    <section
      id="projects"
      className="py-24 px-6 bg-gradient-to-b from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-16">
          <span className="uppercase tracking-[5px] text-sm text-teal-600 font-semibold">
            Our Clients
          </span>

          <h2 className="mt-4 text-4xl md:text-5xl font-bold text-slate-900">
            Projects We've Delivered
          </h2>

          <div className="w-20 h-1 bg-teal-600 mx-auto mt-5 rounded-full"></div>

          <p className="mt-6 text-slate-600 max-w-3xl mx-auto leading-relaxed">
            We partner with businesses to create impactful digital experiences
            through website development, branding, digital marketing, and
            business growth solutions.
          </p>
        </div>

        {/* PROJECT GRID */}
        <motion.div
          layout
          className="grid gap-8 md:grid-cols-2 lg:grid-cols-3"
        >
          <AnimatePresence>
            {projects.map((project, index) => (
              <motion.div
                key={project.title}
                layout
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.4 }}
                whileHover={{ y: -10 }}
                className="group bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-md hover:shadow-2xl transition-all duration-500"
              >
                {/* IMAGE */}
                <div className="relative overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-64 object-cover group-hover:scale-110 transition duration-700"
                  />

                  {/* DARK OVERLAY */}
                  <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-500 flex items-center justify-center">
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white text-slate-900 px-6 py-3 rounded-lg font-semibold shadow-lg hover:bg-slate-100"
                    >
                      View Project
                    </a>
                  </div>

                  {/* PROJECT NUMBER */}
                  <div className="absolute top-4 right-4 bg-white text-slate-900 w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-lg">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                </div>

                {/* CONTENT */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {project.title}
                  </h3>

                  <p className="text-slate-600 text-sm leading-relaxed">
                    {project.desc}
                  </p>

                  <div className="mt-6 pt-4 border-t border-slate-200 flex items-center justify-between">
                    <span className="text-sm text-slate-500">
                      Corporate Client
                    </span>

                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-teal-600 font-semibold text-sm hover:text-teal-700"
                    >
                      Learn More →
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

     
  
      </div>
    </section>
  );
}